<app-tabla
  [datos]="eventosEspera"
  [columnas]="columnas"
  [totalCount]="totalCount"
  [(query)]="query"
  (queryChange)="listar()"
  [filtros]="filtros"
  [search]="null"
  [emptyState]="{
    title: 'No hay eventos en espera',
    subtitle: 'Los eventos que se pongan en espera van a aparecer acá.',
  }"
></app-tabla>
